exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-backdrop[data-v-53ab54d2] {\n    z-index: -1;\n}\n", ""]);

// exports
